import React from 'react';
import Helmet from 'react-helmet';
//import ListManager from '@/Shared/list/ListManager';
//import { usePage } from '@inertiajs/inertia-react';
import { Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION, MagnifierContainer, 
	GlassMagnifier 
} from 'react-image-magnifiers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchPlus, faCartPlus } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

//import '@/../sass/components/_categorias.scss'
//import ProductoListaItem from '@/Shared/Cartera/ProductoListaItem'
import { MainMenu } from '@/constants/Menus';
import { Container, Row, Col, Card, ListGroup, Button, 
	ButtonGroup, Badge, Image, 
} from 'react-bootstrap';
import Breadcrumb from '@/Shared/General/Breadcrumb';
import DefaultMagnifierContainer from "@/Shared/General/DefaultMagnifierContainer";
import { useProps, parrafos } from '@/Shared/FuncComp';
import {whatsappUrlMessage} from '@/utils'
import ProductoBloqueItem from '@/Shared/Cartera/ProductoBloqueItem';

import FormManager from '@/Shared/form/FormManager'
import ListManager from '@/Shared/list/ListManager'
import Link from '@/Shared/Link'

const ProductoRelatedItem = (props) => {
	const {subcategorias={}, marcas={}} = useProps();
	const marca = marcas[props.marca_id]
	const subcat = subcategorias[props.subcategoria_id]
	return (/*<Card {...props.grid} className={"rounded-0 producto-grid"+(props.grid?.className?" "+props.grid.className:"")}>
		<Card.Header className="text-center">{subcat?.name}
			{marca &&<Badge variant="primaryLight" className="text-white">{marca?.name}</Badge>}
		</Card.Header>
		<Card.Img variant="top" src={props.photo} />
		<Card.Body>
			<Card.Title as={Link} link="productos.show" linkParams={[props.id]} className="text-center stretched-link">{props.name}</Card.Title>
		</Card.Body>
	</Card>*/
	<ListGroup.Item className="d-flex position-relative align-items-center pl-1">
		{props.photo && <Image src={props.photo} className="mr-3" />}
		<div className="d-flex flex-column">
			<Link href={route('productos.show', props.id)} className="stretched-link small link">{props.name}</Link>
			{marca && <span className="text-muted mt-2">{marca.name}</span>}
		</div>
	</ListGroup.Item>)
}

const CotizarContent = (props) => {
	const {manager} = props;
	const {SubmitBtn, Form, DestroyBtn} = manager;
	const {cartItem} = manager.props;
	return <Form className="p-0">
		{cartItem && <div className="d-flex align-items-center mb-2">
			<Link link="cotizar" className="link mr-2">Ver lista de cotización <span>(Cantidad actual: {cartItem.qty})</span></Link>
		</div>}
		<div className="d-flex">
			{manager.group({controlId: 'cantidad', className: 'mr-2 mb-0'}, 'Cantidad', {min: 1, placeholder: '###', required: true})}
			<ButtonGroup className="col">
				<SubmitBtn variant={(cartItem?"outline-":"")+"success"} className="col">
					 <span className="col text-center">{cartItem ? "Actualizar cantidad" : <><FontAwesomeIcon icon={faCartPlus} /> Agregar al carrito</>}</span>
				</SubmitBtn>
				{cartItem && <DestroyBtn className="m-0 border-left-0" variant="outline-secondary">
					Remover
				</DestroyBtn>}
			</ButtonGroup>
		</div>
	</Form>
}

export default function Producto(props) {
	const { categoria, subcategoria, producto={}, related, title, cartItem } = useProps();
	
	const cantidadHandler = React.useCallback((e, {manager}) => {
		const val = e.target.value.trim();
		if (/^(?!0)\d*$/.test(val)) {
			manager.setValues({
				[e.target.name]: val?parseInt(val):''
			});
		}
	}, []);
	
	const carteraRoute = MainMenu.find(itm=>itm.route=='cartera.index');
	const ruta = route('productos.show', producto.id);
	
	const enlaceConsultaWhatsapp = whatsappUrlMessage(`Estoy interesado en el producto: ${producto.name}${producto?.subcategoria?' ('+producto?.subcategoria?.name+')':''}\n`+ruta.url());
	
	const generales = [];
	if (producto.marca) generales.push({tag: 'Marca', str_val: producto.marca.name, id: "modelo"});
	if (producto.modelo) generales.push({tag: 'Modelo', str_val: producto.modelo, id: "marca"});
	if (producto.sku_fill) generales.push({tag: 'SKU', str_val: producto.sku_fill, id: "sku"});
	
	const genCardCnt = (generales).map(val=>{
		return <ListGroup.Item key={"attr-"+val.id}>
			<Row>
				<Col xs={4}>
					{val.tag}
				</Col>
				<Col xs className="">
					{val.str_val}
				</Col>
			</Row>
		</ListGroup.Item>
	})
	
	const atributos = (producto.atributos).map(val=>{
		return <ListGroup.Item key={"attr-"+val.id}>
			<Row>
				<Col xs={4}>
					{val.tag}
				</Col>
				<Col xs className="">
					{val.str_val}
				</Col>
			</Row>
		</ListGroup.Item>
	})
	
	return (<>
		{/* <Helmet title="Productos" /> */}
		{/*<h1 className="mb-4 font-bold text-3xl text-center">{title}</h1>*/}
		<Container>
			<Breadcrumb items={[
				{href: route(carteraRoute.route), children: carteraRoute.name},
				categoria && {href: route('cartera.show', categoria?.id), children: categoria?.name, hide: !categoria},
				producto.subcategoria && {href: route('cartera.productos.index', producto.subcategoria?.id), children: producto.subcategoria?.name},
				{children: producto.name, active: true},
			]} />
		</Container>
		<Container fluid="xl">
			<Row as="section">
				<Col md={9}>
					<Row>
						{!!producto.photo && <Col xs="auto">
							<DefaultMagnifierContainer className="border" style={{width: 360, maxHeight: 360}}>
								<Magnifier
									className="input-position"
									//style={{width: 360, height: 360}}
									imageSrc={producto.photo}
									imageAlt={producto.name}
									largeImageSrc={producto.photo_lg}
									touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP}
									dragToMove={false}
								/>
								<Button as="div" variant="light" className="icon-zoom" >
									<FontAwesomeIcon icon={faSearchPlus} />
								</Button>
							</DefaultMagnifierContainer>
						</Col>}
						<Col xs={12} md>
							<h4>{producto.name}</h4>
							<Row>
								{!!producto.modelo && <Col md={6} className="mb-2">
									<b>Modelo:</b> {producto.modelo}
								</Col>}
								{!!producto.marca && <Col md={6} className="mb-2">
									<b>Marca:</b> {producto.marca.name}
								</Col>}
							</Row>
							<hr />
							<Button href={enlaceConsultaWhatsapp} variant="success" target="_blank" className="whatsapp mb-3">
								<FontAwesomeIcon size="2x" icon={faWhatsapp} className="mr-1" />
								 Consultar vía WhatsApp
							</Button>
							<hr />
							<FormManager
								inputToVal={{
									//categoria: categoriaHandler,
									cantidad: cantidadHandler,
								}}
								resource
								route='productos'
								ele={producto}
								submitBaseData={cartItem && {rowId: cartItem.rowId}}
								destroyData={cartItem && {rowId: cartItem.rowId}}
								//setStateVals={setStateVals}
								//hookSetVals
								cartItem={cartItem}
								routeParent="cartera"
								routeParentId={producto.subcategoria?.id||producto.subcategoria_id||undefined}
								component={CotizarContent}
								defValues={({props})=>({
									cantidad: cartItem?.qty
								})}
								dontConfirmDestroy
								only={['cart', 'flash', 'cartItem']}
							/>
							<hr />
							{parrafos(producto.short_description, {props: {
								className: "text-justify"
							}})}
						</Col>
					</Row>
					
					{(genCardCnt!=0 || atributos!=0) && <Row className="justify-content-center pt-4">
						{genCardCnt!=0 && <Col md={9} sm={10}>
							<Card className="mb-4">
								<Card.Header className="text-center">
								<Card.Title className="mb-0">Características Generales</Card.Title>
								</Card.Header>
								<ListGroup variant="flush">
								{genCardCnt}
								</ListGroup>
							</Card>
						</Col>}
						
						{atributos!=0 && <Col md={9} sm={10}>
							<Card className="mb-4">
								<Card.Header className="text-center">
								<Card.Title className="mb-0">Especificaciones</Card.Title>
								</Card.Header>
								<ListGroup variant="flush">
								{atributos}
								</ListGroup>
							</Card>
						</Col>}
					</Row>}
				</Col>
				<Col md={3}>
					<h5>Productos Relacionados</h5>
					<ListManager list={related} /* extras={extras} */ 
						//itemId={categoria.id}
						route="productos" name={'Producto relacionado'} variant="lista" resource
						listaItem={ProductoRelatedItem} noHeader
						//customProps={{cartera: categoria}}
					/>
				</Col>
			</Row>
			<Helmet>
			  <script type="application/ld+json">{JSON.stringify(props.markup)}</script>
			</Helmet>
		</Container>
	</>);
};
